import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { MdOutlineNotifications } from 'react-icons/md';
import { useSelector } from 'react-redux';

import styles from './TopNotificationCount.module.scss';

const cx = classNames.bind(styles);

const TopNotificationCount = ({ robotId }) => {
  const notifications = useSelector((state) => state.notifications);

  const count = useMemo(() => {
    return notifications.filter((notification) => notification.robotId === robotId).length;
  }, [notifications]);

  return (
    <div className={cx('container')}>
      <MdOutlineNotifications size={16} color="white" />
      <div className={cx('count')}>{count}</div>
    </div>
  );
};

export default TopNotificationCount;
